import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../../store';

export default function useUpdateReferralInfoLoading() {
  return useSelector(
    (state: RootState) => state.onboardingQuestionnaire.updateReferralInfoLoading,
  );
}
